// Motif signature : grille des départements couverts

export const DEPARTEMENTS_P1 = [
  { code: "92", nom: "Hauts-de-Seine" },
  { code: "75", nom: "Paris" },
  { code: "78", nom: "Yvelines" },
  { code: "95", nom: "Val-d'Oise" },
  { code: "94", nom: "Val-de-Marne" },
];

export const DEPARTEMENTS_P2 = [
  { code: "91", nom: "Essonne" },
  { code: "77", nom: "Seine-et-Marne" },
  { code: "93", nom: "Seine-Saint-Denis" },
];
